import React, { useState, useEffect, useMemo } from 'react';
import { CrudMasterDetailView, GridView, CompositeView, MasterDetailForm, CrudContext, OptionProps } from '@digital/ui';

import { Area, getAllAreas } from '@app/api/area';
import {
  CrfProjeto,
  getCrfProjetoJoinAgrupador,
  CrfProjetoJoinPacote,
  CrfProjetoPacote,
  getAllCrfProjetosTelaProjeto,
  getAllResumoCrfPlanilhaCapexProjeto,
  getAllResumoCrfPlanilhaRfaProjeto,
  getAllResumoCrfPlanilhaAnoProjeto,
  CrfResumoRfa,
  CrfResumoAnoMes,
  CrfResumoCapex,
} from '@app/api/crf/crfProjeto';
import { getAllTapHasJoinProjeto, TapCicloOrcamentarioHasJoinProjeto, TapJoinProjeto } from '@app/api/crf/crfTap';
import { Diretoria, getAllDiretorias } from '@app/api/diretoria';
import { StatusProjeto, getAllStatusProjeto } from '@app/api/statusProjeto';
import { Departamento, getAllDepartamento } from '@app/api/departamento';
import { Usuario, getAllUsuariosPorPerfil } from '@app/api/usuario';
import { hasPermission } from '@app/helpers/permissions';

import FormDadosProjeto from './FormDadosProjeto';
import FormTapCicloOrcamentario from './FormTapCicloOrcamentario';
import FormProjetoAgrupador from './FormProjetoAgrupador';
import FormTableOrcadoCapexProjeto from './FormTableOrcadoCapexProjeto';
import FormTableOrcadoRfaProjeto from './FormTableOrcadoRfaProjeto';
import FormTableOrcadoAnoProjeto from './FormTableOrcadoAnoProjeto';
import FormTableRequisitadoProjeto from './FormTableRequisitadoProjeto';
import FormTableResumoContratado from './FormTableResumoContratado';
import FormAContratar from './FormAContratar';
import FormADistribuir from './FormADistribuir';
import FormCrfAcronimoProjeto from './FormAcronimoProjeto';
import FormResponsaveisCrfProjeto from './FormResponsaveisProjeto';

import { CrfAcronimoAgrupador, getAllAcronimosAgrupador } from '@app/api/crf/acronimo/Agrupador/acronimosAgrupador';

import {
  updateOrdemByAcronimoAgrupador,
  OrcamentoAcronimoAgrupador,
} from '@app/api/crf/acronimo/Agrupador/tipoAgrupador';

import { StatusRfa, getAllStatusRfa } from '@app/api/statusRfa';
import { getAllTipoDistribuicaoForcastOptions } from '@app/api/tipoDistribuicaoForcast';
import { TipoOptions } from '@app/api/api';
import { CrfAcronimoProjeto, getAllCrfAcronimosProjeto } from '@app/api/crf/acronimo/projeto/crfAcronimosProjeto';
import { CrfTipoProjetoFase, getAllCrfTipoProjetoFase } from '@app/api/crf/crfTipoProjetoFase';
import { getAllCfTipoProjetoGruposOptions } from '@app/api/crf/acronimo/projeto/crfTipoProjetoGrupo';
import { getAllCrfTipoDistribuicaoForcast, getAllTipoOptionTipoDistribuicaoForcast } from '@app/api/crf/crfTipoDistribuicaoForcast';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { aDistribuirProjetoResult, listCrfTipoDistribuicaoForcast, listICrfTipoDistribuicaoForcast } from '@app/state/atom';
import { moduloContaResultado } from '@app/helpers/modulos';
import { ADistribuirViewResult, getADistribuirByCrfProjetoId, SegundoNivel } from '@app/api/crf/crfADistribuir';

const TermoDeAberturaComponent = () => {
  const [areas, setAreas] = useState<Area[]>();
  const [diretorias, setDiretorias] = useState<Diretoria[]>();
  const [acronimos, setAcronimos] = useState<CrfAcronimoProjeto[]>();
  const [departamentos, setDepartamentos] = useState<Departamento[]>();
  const [statusList, setStatusList] = useState<StatusProjeto[]>();
  const [statusRfa, setStatusRfa] = useState<StatusRfa[]>();
  const [fasesList, setFasesList] = useState<CrfTipoProjetoFase[]>();
  const [usuarios, setUsuarios] = useState<Usuario[]>();
  const [crfProjetos, setCrfProjetos] = useState(async () => await getAllCrfProjetosTelaProjeto(moduloContaResultado));
  const [tap, setTap] = useState<TapCicloOrcamentarioHasJoinProjeto[]>();
  const [crfprojetoSelecionado, setCrfProjetoSelectionado] = useState<CrfProjeto>();
  const [projetoPacote, setProjetoPacote] = useState<CrfProjetoPacote[]>();
  const [acronimosPacotes, setAcronimosPacotes] = useState<CrfAcronimoAgrupador[]>();
  const [resumoCapex, setResumoCapex] = useState<CrfResumoCapex[]>();
  const [resumoRfa, setResumoRfa] = useState<CrfResumoRfa[]>();
  const [resumoAno, setResumoAno] = useState<any[]>();
  const [resultTableAnoMes, setResultTableAnoMes] = useState<CrfResumoAnoMes>();
  const [projetoDisciplina, setProjetoDisciplina] = useState<TipoOptions[]>();
  const [updateListaProjetoPacote, setUpdateListaProjetoPacote] = useState(false);
  const setTipoDistribuicaoForcast = useSetRecoilState(listCrfTipoDistribuicaoForcast);
  const setICrfTipoDistribuicaoForcast = useSetRecoilState(listICrfTipoDistribuicaoForcast)
  const [updateADistribuir, setUpdateADistribuir] = useState<boolean>(false)

  const larguraPadrao = 200;
  const larguraNome = 400;
  const [aDistribuirViewModelResult, setADistribuirViewModelResult] = useRecoilState(aDistribuirProjetoResult);
  const [larguraTabela, setLarguraTabela] = useState(0);

  useEffect(() => {
    const getUsuariosData = async () => {
      const result = await getAllUsuariosPorPerfil(7);
      if (result) setUsuarios(result);
    };



    const getDiretoriasData = async () => {
      const result = await getAllDiretorias();
      if (result) setDiretorias(result);
    };


    const hasAllTipoOptionTipoDistribuicaoForcast = async () => {
      const result = await getAllTipoOptionTipoDistribuicaoForcast();
      if (result) {
        setTipoDistribuicaoForcast(result)
      }
      const resulTipo = await getAllCrfTipoDistribuicaoForcast();
      if (resulTipo) {
        setICrfTipoDistribuicaoForcast(resulTipo)
      }

    };

    const getAreasData = async () => {
      const result = await getAllAreas();
      if (result) setAreas(result);
    };

    const getDepartamentosData = async () => {
      const result = await getAllDepartamento();
      if (result) setDepartamentos(result);
    };

    const getAcronimosData = async () => {
      const result = await getAllCrfAcronimosProjeto();
      if (result) setAcronimos(result);
    };

    const getStatusData = async () => {
      const result = await getAllStatusProjeto();
      if (result) setStatusList(result);
    };

    const getStatusRfa = async () => {
      const result = await getAllStatusRfa();
      if (result) setStatusRfa(result);
    };

    const getFasesData = async () => {
      const result = await getAllCrfTipoProjetoFase();
      if (result && Array.isArray(result)) {
        setFasesList(result);
      }
    };

    const getAcronimosPacotes = async () => {
      const result = await getAllAcronimosAgrupador();
      if (result) setAcronimosPacotes(result);
    };

    const getProjetoDisciplinas = async () => {
      const result = await getAllCfTipoProjetoGruposOptions();
      if (result) setProjetoDisciplina(result);
    };

    getUsuariosData();
    getDiretoriasData();
    getAreasData();
    getDepartamentosData();

    getAcronimosData();

    getStatusData();
    getStatusRfa();
    getFasesData();
    getAcronimosPacotes();
    getProjetoDisciplinas();
    hasAllTipoOptionTipoDistribuicaoForcast();
  }, []);

  useEffect(() => {
    if (crfprojetoSelecionado) {
      const join: TapJoinProjeto = {
        projetoId: crfprojetoSelecionado.id,
        cicloOrcamentarioId: '',
      };

      const getTapData = async (t: TapJoinProjeto) => {
        const result = await getAllTapHasJoinProjeto(t);
        if (result) {
          setTap(result);
        }
      };

      getTapData(join);
    }
  }, [crfprojetoSelecionado]);

  const [refazerFuncao, setRefazerFuncao] = useState(false);
  let fn = () => { };

  useMemo(() => {
    fn = () => {
      return `${{ ...crfprojetoSelecionado }}`;
    };
  }, [refazerFuncao]);

  useEffect(() => {
    setRefazerFuncao(!refazerFuncao);
    window.addEventListener('beforeunload', fn);
  }, [crfprojetoSelecionado]);

  useEffect(() => {
    if (crfprojetoSelecionado) {
      const join: CrfProjetoJoinPacote = {
        id: crfprojetoSelecionado.id,
      };
      const getProjetoJoinPacoteData = async (t: CrfProjetoJoinPacote) => {
        const result = await getCrfProjetoJoinAgrupador(t);
        if (result) {
          setProjetoPacote(result);
        }
      };
      getProjetoJoinPacoteData(join);
    }
  }, [crfprojetoSelecionado, acronimosPacotes, updateListaProjetoPacote]);

  useEffect(() => {
    if (crfprojetoSelecionado) {
      const getResumoCapex = async (id: string) => {
        const result = await getAllResumoCrfPlanilhaCapexProjeto(id);
        if (result) setResumoCapex(result);
      };

      const getResumoRfa = async (id: string) => {
        const result = await getAllResumoCrfPlanilhaRfaProjeto(id);
        if (result) setResumoRfa(result);
      };

      const getResumoAno = async (id: string) => {
        const result = await getAllResumoCrfPlanilhaAnoProjeto(id);
        if (result) {
          setResultTableAnoMes(result);
          setResumoAno(result.resultDataTabel);
        }
      };

      getResumoCapex(crfprojetoSelecionado.id);
      getResumoRfa(crfprojetoSelecionado.id);
      getResumoAno(crfprojetoSelecionado.id);
    }
  }, [crfprojetoSelecionado]);

  const handleUpdate = async (t: OrcamentoAcronimoAgrupador) => {
    if (t) {
      const result = await updateOrdemByAcronimoAgrupador(t);
      if (result) {
        listarAcronimosPacotes();
      }
    }
  };

  const listarAcronimosPacotes = async () => {
    setAcronimosPacotes([]);
    const result = await getAllAcronimosAgrupador();
    if (result) setAcronimosPacotes(result);
  };

  const handler = async () => {
    setCrfProjetos(() => Promise.resolve(undefined));
    setCrfProjetos(async () => await getAllCrfProjetosTelaProjeto(moduloContaResultado));
  };

  const onUpdateListaProjetoPacote = () => {
    setUpdateListaProjetoPacote(!updateListaProjetoPacote);
  };

  const hasGetADistribuirByCrfProjetoId = (crfProjetoId: string, consultaRelatorio: boolean) => {
    getADistribuirByCrfProjetoId(crfProjetoId, consultaRelatorio)
      .then((viewModel) => {
        if (viewModel) {

          const totalColunaADistribuir = viewModel.colunasADistribuir.length;
          const totalColubasExecutado = viewModel.colunasExecutadoMesAno.length;
          const larguraTotal = (larguraPadrao * 15) + ((totalColunaADistribuir + totalColubasExecutado) * larguraPadrao + larguraNome);
          setLarguraTabela(larguraTotal);

          viewModel
            .children
            .forEach((primeiroNivel) => {
              if (primeiroNivel && primeiroNivel.children) {
                primeiroNivel.children.forEach((tercieiroNivel) => {
                  if (tercieiroNivel.children && tercieiroNivel.children.length == 0) {
                    tercieiroNivel.children = undefined;
                  } else {

                  }
                })
              }
            })

          calcarTotalizadorADistribuir(viewModel);
          setADistribuirViewModelResult(viewModel);
        }
      })
  }

  const calcarTotalizadorADistribuir = (adistribuir: ADistribuirViewResult) => {

    if (adistribuir.children && adistribuir.children.length) {
      adistribuir
        .children
        .forEach((primeiroNivel) => {
          adistribuir
            .colunasADistribuir
            .forEach((colunaADistribuir) => {
              let totalColunaADistibuir = 0;
              if (primeiroNivel.children && primeiroNivel.children.length)
                totalColunaADistibuir = obterTotalColunaADistribuirNivel1(primeiroNivel.children, colunaADistribuir.key);

              primeiroNivel[`${colunaADistribuir.key}`] = totalColunaADistibuir;
            });
        });
    }
    adistribuir
      .colunasADistribuir
      .map((colunaADistribuir) => {

        let totalColunaADistibuirPrimeiroNivel = 0;

        if (adistribuir.children && adistribuir.children.length) {

          adistribuir
            .children
            .map((primeiroNivel) => {
              const valorPrimeiroNivel = primeiroNivel[`${colunaADistribuir.key}`]
              if (valorPrimeiroNivel != undefined) {
                totalColunaADistibuirPrimeiroNivel += valorPrimeiroNivel;
              }
            })
        }
        colunaADistribuir.totalColuna = totalColunaADistibuirPrimeiroNivel;
      })

  }

  const obterTotalColunaADistribuirNivel1 = (listSegundoNivel: Array<SegundoNivel>, keyColuna: string): number => {
    let totalTerceiroNivel = 0;
    listSegundoNivel
      .map((segundoNivel) => {
        if (segundoNivel.children && segundoNivel.children.length) {
          segundoNivel
            .children
            .map((terceiroNivel) => {
              const valorTerceiroNivel = terceiroNivel[`${keyColuna}`]
              if (valorTerceiroNivel != undefined) {
                totalTerceiroNivel += valorTerceiroNivel;
              }
            })
        }
      })

    return totalTerceiroNivel;
  }

  return (
    <CrudMasterDetailView
      getAllItems={() => crfProjetos}
      disableNotification
      icon="editing-overview_pages_1"
      detailTitleExtractor={item => `${item.codigo} - ${item.nome} - ${item.statusNome}`}
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        item.crfDisciplinaProjetoNome.toLowerCase().includes(value.toLowerCase()) ||
        (item.codigo && item.codigo.toLowerCase().includes(value.toLowerCase())) ||
        (item.statusNome && item.statusNome.toLowerCase().includes(value.toLowerCase())) ||
        item.numero.toLowerCase().includes(value.toLowerCase())
      }
      titleExtractor={item => `${item.codigo} - ${item.nome}`}
      descriptionExtractor={item => item.crfDisciplinaProjetoNome || ''}>
      <CrudContext.Consumer>
        {({ selectedItem }) => {
          setCrfProjetoSelectionado(selectedItem);
          return (
            <CompositeView>
              {hasPermission(['Dono', 'PROJETO_ABA_GERAL_VISUALIZAR_ABA']) ? (
                <GridView icon="editing-overview_pages_1" id="geral" noform title="GERAL">
                  <>
                    <MasterDetailForm>
                      <FormDadosProjeto
                        selectedItem={selectedItem}
                        statusList={statusList || []}
                        fasesList={fasesList || []}
                        projetoUpdate={crfprojetoSelecionado || selectedItem}
                        statusRfaList={statusRfa || []}
                        handler={handler}
                      />
                      <FormCrfAcronimoProjeto
                        selectedItem={selectedItem}
                        acronimos={acronimos || []}
                        projetoDisciplina={projetoDisciplina || []}
                      />
                      <FormResponsaveisCrfProjeto
                        selectedItem={selectedItem}
                        usuarios={usuarios || []}
                        areas={areas || []}
                        diretorias={diretorias || []}
                        departamentos={departamentos || []}
                      />
                    </MasterDetailForm>
                  </>
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['Dono', 'PROJETO_ABA_TAP_VISUALIZAR']) ? (
                <GridView icon="ecommerce-attention" id="tap" noform title="TAP">
                  <>
                    {tap &&
                      tap.map(t => (
                        <FormTapCicloOrcamentario
                          key={t.tapAno}
                          areas={areas || []}
                          departamentos={departamentos || []}
                          diretorias={diretorias || []}
                          tapDiretoriaId={t.tapDiretoriaId}
                          tapDepartamentoId={t.tapDepartamentoId}
                          tapAreaId={t.tapAreaId}
                          tapEscopoAnual={t.tapEscopoAnual}
                          tapAno={t.tapAno}
                          tapId={t.tapId}
                          initialValues={t}
                          keyId={t.tapId}
                        />
                      ))}
                  </>
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['Dono', 'PROJETO_ABA_PACOTES_VISUALIZAR']) ? (
                <GridView icon="ecommerce-box" id="agrupador" noform title="Agrupador">
                  <FormProjetoAgrupador
                    acronimos={
                      acronimosPacotes && acronimosPacotes.map(a => ({ text: a.sigla, value: a.id.toString() }))
                    }
                    projetoPa={projetoPacote || []}
                    handleUpdate={handleUpdate}
                    onUpdate={onUpdateListaProjetoPacote}
                    crfprojetoSelecionado={crfprojetoSelecionado}
                  />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['Dono', 'PROJETO_ABA_ORCADO_VISUALIZAR']) ? (
                <GridView icon="business-estimate" id="Orcado" noform title="Orçado">
                  <FormTableOrcadoCapexProjeto
                    resumoCapex={resumoCapex || []}
                    projetoId={(crfprojetoSelecionado && crfprojetoSelecionado.id) || ''}
                  />
                  <FormTableOrcadoRfaProjeto
                    resumoRfa={resumoRfa || []}
                    projetoId={(crfprojetoSelecionado && crfprojetoSelecionado.id) || ''}
                  />
                  <FormTableOrcadoAnoProjeto
                    resumoAno={resumoAno || []}
                    resultTableAnoMes={resultTableAnoMes || ({} as CrfResumoAnoMes)}
                  />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['Dono', 'PROJETO_ABA_ORCADO_VISUALIZAR']) && selectedItem ? (
                <GridView icon="messaging-send_file" id="requisitado" noform title="Requisitado">
                  <FormTableRequisitadoProjeto projetoId={selectedItem.id} />
                </GridView>
              ) : (
                () => { }
              )}

              {hasPermission(['Dono', 'PROJETO_ABA_ORCADO_VISUALIZAR']) && selectedItem ? (
                <GridView icon="business-agreement" id="contratado" noform title="Contratado">
                  <FormTableResumoContratado
                    projetoId={selectedItem.id}
                  />
                </GridView>
              ) : (
                () => { }
              )}


              {hasPermission(['Dono', 'PROJETO_ABA_ORCADO_VISUALIZAR']) && selectedItem ? (
                <GridView icon="files-new_by_copy" id="aContratar" noform title="A CONTRATAR">
                  <FormAContratar selectedItem={selectedItem} hasGetADistribuirByCrfProjetoId={hasGetADistribuirByCrfProjetoId} />
                </GridView>
              ) : (
                () => { }
              )}

              {hasPermission(['Dono', 'PROJETO_ABA_ORCADO_VISUALIZAR']) && selectedItem ? (
                <GridView icon="business-accounting" id="aDistribuir" noform title="A DISTRIBUIR">
                  {<FormADistribuir selectedItem={selectedItem} hasGetADistribuirByCrfProjetoId={hasGetADistribuirByCrfProjetoId} larguraTabela={larguraTabela} />}
                </GridView>
              ) : (
                () => { }
              )}
            </CompositeView>
          );
        }}
      </CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default TermoDeAberturaComponent;
